module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hideOutliers":"Hide outliers"},"it":{"hideOutliers":"Nascondi outliers"}}')
  delete Component.options._Ctor
}
